export function tryOrNull<P extends unknown[], R>(functionCallback: (...args: P) => R): (...args: P) => R | null {
	return (...args: P): R | null => {
		try {
			return functionCallback(...args);
		} catch {
			return null;
		}
	};
}

export function tryOrNullAsync<P extends unknown[], R>(
	functionCallback: (...args: P) => Promise<R>,
): (...args: P) => Promise<R | null> {
	return async (...args: P): Promise<R | null> => {
		try {
			return await functionCallback(...args);
		} catch {
			return null;
		}
	};
}
